import { IonAlert, IonButton, IonIcon, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup } from '@ionic/react';
import { removePaymentCard, updateProfile } from '../../store/actions';
import { cardOutline, removeCircleOutline,  trashBinOutline } from 'ionicons/icons';
import { NormalText, Spacer, StrongText } from '../../components/common';
import { isDefined, isWebConfig } from '../../lib/utils';
import { withTranslation } from '../../lib/translate';
import Basket from '../../lib/basket';
import { connect } from 'react-redux';
import React from 'react';
import './index.css';
import { ReactComponent as CardDefault } from '../../assets/images/card-default.svg';

class CardList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removeCardAlert: null,
      selectPaymentCard: this.props.profile.cardToken || null,
    };
  }
  componentDidMount() {
    if (this.props.profile && this.props.profile?.cardToken) {
      Basket.changeSelectedCard(this.props.profile?.cardToken);
      this.setState({ selectPaymentCard: this.props.profile.cardToken });

    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.profile.cardToken !== this.props.profile.cardToken) {
      this.setState({ selectPaymentCard: this.props.profile.cardToken });
    }
  }

  changeDefaultPaymentCard = (event) =>
    this.setState({ selectPaymentCard: event.detail.value }, () => {
      this.props.dispatch(updateProfile({ cardToken: event.detail.value }, true));
    });

  removePaymentCard = () => {
    const { __ } = this.props;
  
    this.props.dispatch(
      removePaymentCard(this.state.removeCardAlert, {
        __,
        cb: () => this.setState({ removeCardAlert: null }),
      }),
    );
  };
  changeSelectedPaymentCard = (cardId) =>
    this.setState({ selectPaymentCard: cardId }, () => {
      Basket.changeSelectedCard(cardId);
    });

  handleRemoveCardAlert = (cardId) => {
    if (cardId) {
      this.setState({ removeCardAlert: cardId })
    }else{
      this.setState({ removeCardAlert: null })

    }
  };

  render() {
    const { __, cards } = this.props;
    const { removeCardAlert } = this.state;
    return (
      <>
        <IonList lines="none">
          <IonRadioGroup value={this.state.selectPaymentCard}>
            {cards.map((card) => {
              const { id, last4, brand, exp_month, exp_year, name } = card;
              return (
                <IonItem lines="none" className="cards-list-card box-content order-summary-card" key={id} >

                  <div className="card-icon-wrapper">
                    <CardDefault />

                  </div>
                  <IonLabel className="ion-text-wrap" onClick={() => this.changeSelectedPaymentCard(id)}>
                    <StrongText > {__(brand)} - {exp_month}/{exp_year}
                    </StrongText>
                    <Spacer size={0} />
                    <StrongText className=" block">**** **** **** {last4}</StrongText>

                  </IonLabel>
                  <IonButton fill='clear' onClick={() => this.handleRemoveCardAlert(id)}>
                    <IonIcon style={{ height: '20px', width: '20px' }} icon={trashBinOutline} className="remove-card-icon" />
                  </IonButton>

                  <IonRadio
                    color={'primary'}
                    slot="start"
                    value={id}
                    onIonSelect={() => {
                      this.setState({ selectPaymentCard: id }, () => {
                        Basket.changeSelectedCard(id);
                      });
                    }}
                  />
                </IonItem>
              );
            })}
          </IonRadioGroup>
        </IonList>
        <IonAlert
          isOpen={isDefined(removeCardAlert)}
          onDidDismiss={() => this.handleRemoveCardAlert(null)}
          message={__('Do you want to remove this card?')}
          buttons={[

            {
              text: __('Remove'),
              handler: () => this.removePaymentCard(),
              cssClass: 'primary'
            },
            {
              text: __('Cancel'),
              role: 'cancel',
              cssClass: 'secondary link',
            },
          ]}
        />
      </>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    cards: store.orders.cards || [],
    profile: store.profile.profile || {},
  };
};

export default connect(mapStateToProps)(withTranslation(CardList));
